export const criadoresIcones = [
  {
    url: 'https://www.freepik.com',
    title: 'Freepik',
    name: 'Freepik',
  },
  {
    url: 'https://www.flaticon.com/authors/srip',
    title: 'srip',
    name: 'srip',
  },
  {
    url: 'https://www.flaticon.com/authors/catkuro',
    title: 'catkuro',
    name: 'catkuro',
  },
  {
    url: 'https://www.flaticon.com/authors/monkik',
    title: 'monkik',
    name: 'monkik',
  },
  {
    url: 'https://www.flaticon.com/authors/mavadee',
    title: 'mavadee',
    name: 'mavadee',
  },
  {
    url: 'https://www.flaticon.com/authors/eucalyp',
    title: 'Eucalyp',
    name: 'Eucalyp',
  },
];

export default { criadoresIcones };
